import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpRequest } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class SalesFileService {

  constructor(private readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }


  getAllSalesFileTypeTypes() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getSalesFileType`);
  }
  getSalesFileData() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getSalesFileData`);
  }
  getUserTargetFilesData() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetFilesData`);
  }
  getUserTargetFileDataById(fileId) {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetFileDataById?fileId=${fileId}`);
  }

  approveUserTargetFile(model) {
    return this.http.post(`${this.configurations.apiAddress}/api/SalesFile/approveUserTargetFile`, model);
  }


  provisionIbnSina(formData) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/uploadIbnSinaTemplate`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  provisionPOS(formData) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/uploadPOSTemplate`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  provisionUCP(formData) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/uploadUCPTemplate`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  provisionEgyDrug(formData) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/uploadEgyDrugTemplate`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  provisionDirect(formData) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/uploadDirectTemplate`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  /** background = true: the server answers { jobId } and works in the background (follow it with UploadJobService) */
  provision(formData, typeId, selectedDate, applyDistributorPrice, isHco = true, background = false) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/SalesFile/upload?type=` + typeId + `&date=` + selectedDate.toDateString() + `&applyDistributorPrice=` + applyDistributorPrice + `&isHco=` + isHco + (background ? `&background=true` : ``), formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);

  }

  downloadCsvTemplate(typeId): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadCSVTemplate?type=" + typeId, { responseType: "blob" });
  }

  delete(id) {
    return this.http.delete(this.configurations.apiAddress + '/api/SalesFile/delete/' + id);
  }


  getDitributors() {
    return this.http.get(`${this.configurations.apiAddress}/api/Distributor/search`);
  }
  getSalesFileDistributorsData() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getSalesFileDistributorsData`);
  }

  downloadDistributorSalesCSVTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadDistributorSalesCSVTemplate", { responseType: "blob" });
  }

  downloadDistributorSalesErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadDistributorSalesErrorFile", { responseType: "blob" });
  }
  downloadUserTargetErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadUserTargetErrorFile", { responseType: "blob" });
  }

  downloadTargetErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadTargetErrorFile", { responseType: "blob" });
  }

  downloadUploadedFile(id: number) {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadUploaded/" + id, { responseType: "blob" });
  }

  /** Same upload as uploadDistributorSalesCSVTemplate, in the background with progress (answers { jobId }; follow it with UploadJobService). */
  uploadDistributorSalesWithProgress(formData, distributorId, selectedDate, applyDistributorPrice) {
    const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + "/api/SalesFile/uploadDistributorSalesCSVTemplate?distributorId=" + distributorId + "&date=" + selectedDate.toDateString() + `&applyDistributorPrice=` + applyDistributorPrice + `&background=true`, formData, {
      reportProgress: true,
    });
    return this.http.request(uploadReq);
  }

  uploadDistributorSalesCSVTemplate(formData, distributorId, selectedDate, applyDistributorPrice) {
    return this.http.post(this.configurations.apiAddress + "/api/SalesFile/uploadDistributorSalesCSVTemplate?distributorId=" + distributorId + "&date=" + selectedDate.toDateString() + `&applyDistributorPrice=` + applyDistributorPrice, formData);
  }

  getPharmacySalesFileData() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getPharmacySalesFileData`);
  }

  downloadPharmacySalesCSVTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadPharmacySalesCSVTemplate", { responseType: "blob" });
  }

  downloadPharmacySalesErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/SalesFile/downloadPharmacySalesErrorFile", { responseType: "blob" });
  }

  uploadPharmacySalesCSVTemplate(formData, distributorId, selectedDate, applyDistributorPrice) {
    return this.http.post(this.configurations.apiAddress + "/api/SalesFile/uploadPharmacySalesCSVTemplate?distributorId=" + distributorId + "&date=" + selectedDate.toDateString() + `&applyDistributorPrice=` + applyDistributorPrice, formData);
  }

  /** the pharmacy sales upload in the background with progress (answers { jobId }; follow it with UploadJobService) */
  uploadPharmacySalesWithProgress(formData, distributorId, selectedDate, applyDistributorPrice) {
    return this.http.request(new HttpRequest("POST", this.configurations.apiAddress + "/api/SalesFile/uploadPharmacySalesCSVTemplate?distributorId=" + distributorId + "&date=" + selectedDate.toDateString() + `&applyDistributorPrice=` + applyDistributorPrice + `&background=true`, formData, { reportProgress: true }));
  }

  getUserTargetRequests() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetRequests`);
  }
  getUserTargetRequestsTree() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetRequestsTree`);
  }
  getUserTargetRequestById(requestId) {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetRequestById?requestId=${requestId}`);
  }

  saveUserTargetRequest(model) {
    return this.http.post(`${this.configurations.apiAddress}/api/SalesFile/saveUserTargetRequest`, model);
  }

  deleteUserTargetRequest(requestId) {
    return this.http.delete(this.configurations.apiAddress + '/api/SalesFile/deleteUserTargetRequest/' + requestId);
  }

  getUserTargetRequestApprovalUsers() {
    return this.http.get(`${this.configurations.apiAddress}/api/SalesFile/getUserTargetRequestApprovalUsers`);
  }

  getUserTargetRequestApprovalUsersByUrl(url): Observable<any[]> {
    const URL = `${url}/api/SalesFile/getUserTargetRequestApprovalUsers`;
    const response = this.http.get<any[]>(URL);
    return response;

  }


  saveUserTargerRequestApprovalUsers(model) {
    return this.http.post(`${this.configurations.apiAddress}/api/SalesFile/saveUserTargerRequestApprovalUsers`, model);
  }
}
